import { render, staticRenderFns } from "./DictManagement.vue?vue&type=template&id=eb754554&scoped=true"
import script from "./DictManagement.vue?vue&type=script&lang=js"
export * from "./DictManagement.vue?vue&type=script&lang=js"
import style0 from "./DictManagement.vue?vue&type=style&index=0&id=eb754554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb754554",
  null
  
)

export default component.exports